const ERPNEXT_URL = "https://erpdev.ohs.global"; // workfreeli erp

export default function ERPNextLauncher(userMe, label) {
    // console.log("Launching ERPNext for user:", userMe);
    if (!userMe?.erpNext) {
        alert("You have no module access. Please contact your administrator.");
        return;
    }

    if (window.screen && window.screen.width < 1000) {
        alert(
            "Popup blocked. Please allow popups for this site or use a larger screen."
        );
        return;
    }

    let newTab = window.open("", "_blank", "width=1200,height=800");
    if (!newTab) {
        alert("Popup was blocked. Please allow popups for this site.");
        return;
    }

    const formHtml = `
    <html>
      <head>
        <style>
          body { margin:0; display:flex; justify-content:center; align-items:center; height:100vh; font-family:sans-serif; }
          .dot_loader { width:100px; height:100px; background-image:url('https://wfss001.freeli.io/common/hayvenCircularDots.svg'); background-repeat:no-repeat; background-position:center; background-size:contain; }
          .msg { margin-top:20px; font-size:16px; color:#555; }
        </style>
      </head>
      <body>
        <form id="erpForm" action="${ERPNEXT_URL}/api/method/login" method="POST">
          <input type="hidden" name="usr" value="${userMe?.email}" />
          <input type="hidden" name="pwd" value="${userMe?.erpNextPass}" />
        </form>
        <div class="loaderMain"></div>
        <script>
          try {
            document.getElementById('erpForm').submit();
          } catch(err) {
            document.body.innerHTML = '<div style="color:red;font-family:sans-serif">Login Failed: ' + err.message + '</div>';
          }
        </script>
      </body>
    </html>
  `;

    try {
        newTab.document.write(formHtml);
        newTab.document.close();
    } catch (err) {
        console.error("Tab write error:", err);
        return;
    }

    setTimeout(() => {
        try {
            let land = "/app";
            if (label.toLowerCase().includes("dashboard")) land += "/dashboards";
            else if (label.toLowerCase().includes("sales")) land += "/selling";
            else if (label.toLowerCase().includes("purchase")) land += "/buying";
            else if (label.toLowerCase().includes("account")) land += "/accounting";
            else if (label.toLowerCase().includes("inventory")) land += "/stock";
            else if (label.toLowerCase().includes("manufacturing")) land += "/stock";
            else if (label.toLowerCase().includes("admin")) land += "/users";

            console.log("Redirecting to:", `${ERPNEXT_URL}${land}`);
            newTab.location.href = `${ERPNEXT_URL}${land}`;
        } catch (e) {
            console.error("Redirect error:", e);
        }
    }, 2000);
}
